module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_8017.17ea3872.png";